import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/productdetail/afterpay.scss';

interface AfterPayProps {
  isProductAfterpayEligible: boolean;
  priceDollarValue: string;
  priceCentsValue: string;
}

export const AfterPay = ({ isProductAfterpayEligible, priceDollarValue, priceCentsValue }: AfterPayProps) => {
  const { testId } = useMartyContext();

  return (
    <div className={css.afterpayPlacement} data-test-id={testId('afterpay')}>
      <afterpay-placement
        data-locale="en_US"
        data-currency="USD"
        data-is-eligible={isProductAfterpayEligible}
        data-amount={`${priceDollarValue}${priceCentsValue && '.'}${priceCentsValue}`}
        data-logo-type="lockup"
        data-size="sm"
        data-modal-theme="white"
        data-show-interest-free={false}
      />
    </div>
  );
};

export default AfterPay;
